<template>
    <EditingDialog
        :context="context"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
        :useDifferentShowDialogProp="true"
        :additionalSaveFunction="additionalSaveFunction"
        :useAdditionalSaveFunction="true"
        :additionalAfterSaveFunction="saveApiCall"
        maxDialogWidth="1200"
    >
        <template v-slot:editForm>
            <v-row>
                <v-col cols="5">
                    <!--  -->
                    <BaseEditPageAutocomplete 
                        v-if="!isTrackTitleReadOnly"
                        :context="context"
                        field="TrackTitle"
                        :label="$t('lang_CONTRACTS_LABEL_CAPTION_TRACKS_TITLE')"
                        :withMargin="false"
                        rules="required"
                        :additionalFunction="fillInReleasesDropdown"
                        :alvqa="alvqa + '-autocomplete-track-title-textfield'"
                    >
                        <template v-slot:selection="{ item }">
                            <div class="ellipsis" :alvqa="alvqa + '-autocomplete-track-title-selection'">
                                {{ getTitleForAutocomplete(item) }}
                            </div>
                        </template>
                        <template v-slot:items="{ items }">
                            <v-list-item-content :alvqa="alvqa + '-autocomplete-track-title-dropdown-' + items.alvId">
                                <v-list-item-title :alvqa="alvqa + '-autocomplete-track-title-dropdown-' + items.alvId + '-track-title'">
                                    {{ items.title }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </template>
                    </BaseEditPageAutocomplete>
                    <BaseReadOnlyTextField
                        v-if="isTrackTitleReadOnly"
                        :innerValue="getTrackTitel"
                        :label="$t('lang_CONTRACTS_LABEL_CAPTION_TRACKS_TITLE')"
                        :alvqa="alvqa + '-readonly-track-title-textfield'"
                    />
                </v-col>
                <v-col cols="6">
                    <BaseEditPageDropdown 
                        :context="context"
                        field="SelectedReleases"
                        :items="releaseTitleDropdownItems" 
                        :label="$t('lang_CONTRACTS_LABEL_CAPTION_RELEASE_TITLE')"
                        :selection="true"
                        :withMargin="false"
                        :clearable="false"
                        :multiple="true"
                        :allSelect="true"
                        :rules="releaseTitleDropdownItems.length !== 0 ? 'required' : ''"
                        :alvqa="alvqa + '-dropdown-release-title'"
                    />
                </v-col>
            </v-row>
        </template>
    </EditingDialog>
</template>

<script>
import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageAutocomplete from '@/components/_editForm/BaseEditPageAutocomplete'
import BaseReadOnlyTextField from '@/components/_readonly/BaseReadOnlyTextField'

export default {
    name: "TracksReleasesEditPanelDialog",
    components: {
        EditingDialog,
        BaseEditPageDropdown,
        BaseEditPageAutocomplete,
        BaseReadOnlyTextField
    },
    data() {
        return {
            context: "LabelContractsTracksReleases",
            alvqa: "contracts-label-edit-form-tracks-releases-panel-editing-dialog"
        }
    },
    computed: {
        releaseTitleDropdownItems() {
            let selectedTrack = this.$store.getters.getLabelContractsTracksReleasesEditingDialogDetails
            let releases = []

            if(selectedTrack !== null && selectedTrack !== undefined) {
                selectedTrack.releases.forEach(release => {
                    let tempText = release.title
                    tempText += ' (EAN: ' + (release.ean !== null ?  release.ean : this.$t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM'))
                    tempText += ', ' + this.$t('lang_GENERIC_CAPTION_CATALOGUE_NUMBER')+ ': ' + (release.catalogueNumber !== null ? release.catalogueNumber : this.$t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM')) + ')'
                    releases.push({
                        value: release.alvId,
                        text: tempText
                    })
                })
            } 

            return releases
        },
        isTrackTitleReadOnly: {
            get() { return this.$store.getters.getLabelContractsIsTrackTitelReadOnly },
            set(value) { this.$store.commit('setLabelContractsIsTrackTitelReadOnly', value) }
        },
        getTrackTitel() { return this.$store.getters.getLabelContractsTracksReleasesEditingDialogDetails.title },
    },
    methods: {
        async fillInReleasesDropdown(item) {
            if(item !== null && item !== undefined) {
                // get releases that are available for this track
                await this.$store.dispatch('fetchTracksDetails', item.alvId)
                this.$store.commit('setLabelContractsTracksReleasesEditingDialogDetails', this.$store.getters.getTracksDetails)
            } else {
                this.$store.commit('setLabelContractsTracksReleasesDetailsSelectedReleases', [])
                let defaultValues = JSON.parse(JSON.stringify(this.$store.getters.getDefaultLabelContractsTracksReleases)) 
                this.$store.commit('setLabelContractsTracksReleasesEditingDialogDetails', defaultValues)
            }
        },
        getTitleForAutocomplete(item) {
            if (
                typeof item === 'object' &&
                !Array.isArray(item) &&
                item !== null
            ) {
                return item.title
            } else return item
        },
        additionalSaveFunction(item) {
            let selectedReleases = item.selectedReleases
            let mapppedSelectedReleases = selectedReleases.map(element => {
                if (
                    typeof element === 'object' &&
                    !Array.isArray(element) &&
                    element !== null
                ) {
                    return element['value']
                } else return element
            })

            this.$store.commit('setLabelContractsTracksReleasesDetailsSelectedReleases', mapppedSelectedReleases)
        },
        saveApiCall() { this.$store.dispatch('addTrackToLabelContract')}
    }
}
</script>